module.exports = {
  // Generic field type
  AMOUNT: 'amount',
  COUNTRY: 'country',
  DATE: 'date',
  CURRENCY: 'currency',
  TEXT: 'text',
  ID: 'id',
  OBJECT_ID: 'object_id',
  STATUS: 'status',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  COUNT: 'count',
  // Specific field type with list (static or async)
  AUTHENTICATION_PARTNER: 'authentication_partner',
  AUTHENTICATION_REQUEST_STATUS: 'authentication_request_status',
  AUTHENTICATION_RESULT: 'authentication_result',
  AUTHORIZATION_CODE: 'authorization_code',
  AUTHORIZATION_REQUEST_STATUS: 'authorization_request_status',
  AUTHORIZATION_STATUS: 'authorization_status',
  BASKET_TYPE: 'basket_type',
  CANCELLATION_REQUEST_STATUS: 'cancellation_request_status',
  CANCELLATION_STATUS: 'cancellation_status',
  CAPTURE_REQUEST_STATUS: 'capture_request_status',
  CAPTURE_STATUS: 'capture_status',
  CASHIER_PARTNER: 'cashier_partner',
  CHARGEBACK_REASON: 'chargeback_reason',
  CHARGEBACK_REASON_CODE: 'chargeback_reason_code',
  CHALLENGE_PREFERENCE: 'challenge_preference',
  CUSTOMER_ACCOUNT_LOGIN_TYPE: 'customer_account_login_type',
  DEVICE_TYPE: 'device_type',
  INTEGRATION_TYPE: 'integration_type',
  MERCHANT_ACCOUNT: 'merchant_account',
  MERCHANT_CONTRACT: 'merchant_contract',
  MERCHANT_DATA: 'merchant_data',
  MERCHANT_ROUTE: 'merchant_route',
  PAYIN_PARTNER: 'payin_partner',
  PAYMENT_CHANNEL: 'payment_channel',
  PAYMENT_METHOD: 'payment_method',
  PAYMENT_METHOD_TYPE: 'payment_method_type',
  PSP_RESULT_CODE: 'psp_result_code',
  RECONCILIATION_REASON: 'reconciliation_reason',
  WITHDRAW_REASON: 'withdraw_reason',
  RECONCILIATION_TYPE: 'reconciliation_type',
  REFUND_REASON: 'refund_reason',
  REFUND_REQUEST_STATUS: 'refund_request_status',
  REFUND_STATUS: 'refund_status',
  RISK_ASSESSMENT_PARTNER: 'risk_assessment_partner',
  RISK_ASSESSMENT_REASON: 'risk_assessment_reason',
  RISK_ASSESSMENT_REASON_CODE: 'risk_assessment_reason_code',
  SCA_EXEMPTION_REASON: 'sca_exemption_reason',
  SHIPPING_DELIVERY_METHOD: 'shipping_delivery_method',
  SOURCE: 'source',
  STATUS_RESULT: 'status_result',
  TYPE: 'type',
  FINANCIAL_OPERATION_TYPE: 'financial_operation_type',
  FINANCIAL_OPERATION_FEE_TYPE: 'financial_operation_fee_type',
  FINANCIAL_OPERATION_MOVEMENT: 'financial_operation_movement',
  OPERATION_TYPE: 'operation_type',
  CARD_CATEGORY: 'card_category',
  CARD_TYPE: 'card_type',
  ENVIRONMENT: 'environment',
  // INTERCHANGE_ZONE: 'interchange_zone',
  PARTNER_TYPE: 'partner_type',
  NOTIFICATION_STATUS: 'notification_status',
  WEBHOOK: 'webhook',
  COMPANY: 'company',
  PROGRAM_MANAGER: 'program_manager',
  META_PROGRAM_MANAGER: 'meta_program_manager',
  // Specific type for log
  LOG_UPDATE: 'log_update',
  LOG_ENTITY_ID: 'log_entity_id',
  LOG_ENTITY_TYPE: 'log_entity_type',
  // Checkout
  CHECKOUT_TYPE: 'checkout_type',
  TOKEN_TYPE: 'token_type',
};
